import React, { FunctionComponent } from 'react';

interface ContainerInterface {
    extraClass?: string;
}

export const Container: FunctionComponent<ContainerInterface> = ({ extraClass = '', children }) => (
    <div className={`o-container ${extraClass}`}>{children}</div>
);
